const config = {
  key: "swp-comprehensive",
  title: "SWP Comprehensive",
  category: "Retirement & Income",
  description: "A full year-by-year SWP schedule where the withdrawal itself rises every year.",
  fields: [
    { key: "corpus", label: "Corpus", type: "currency", default: 50_00_000, min: 1000, max: 50_00_00_000 },
    { key: "withdrawal", label: "Starting monthly withdrawal", type: "currency", default: 30_000, min: 500, max: 50_00_000 },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 7, min: 1, max: 20, assumptionKey: "debtReturn" },
    { key: "stepUpPct", label: "Annual step-up in withdrawal", type: "percent", default: 5, min: 0, max: 30, help: "How much your monthly withdrawal rises each year (e.g. to keep pace with inflation)." },
  ],
  chart: {
    type: "line",
    xKey: "year",
    series: [{ key: "balance", label: "Remaining balance", colorVar: "--gold" }],
  },
  compute(values) {
    const corpus = Number(values.corpus) || 0;
    const startWithdrawal = Number(values.withdrawal) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const stepUpPct = (Number(values.stepUpPct) || 0) / 100;
    const i = annualRate / 12;

    let balance = corpus;
    let withdrawal = startWithdrawal;
    let totalWithdrawn = 0;
    let endMonth = null;
    const capMonths = 100 * 12;
    const series = [];

    for (let m = 1; m <= capMonths; m++) {
      balance = balance * (1 + i) - withdrawal;
      totalWithdrawn += withdrawal;
      if (balance <= 0) {
        balance = 0;
        endMonth = m;
      }
      if (m % 12 === 0 || endMonth) {
        series.push({ year: Math.ceil(m / 12), balance });
      }
      if (endMonth) break;
      if (m % 12 === 0) withdrawal *= 1 + stepUpPct;
    }

    return {
      headline: { label: "Corpus lasts", value: endMonth, format: "months" },
      extraHeadlines: [{ label: "Monthly withdrawal at the end", value: withdrawal }],
      breakdown: [
        { label: "Starting corpus", value: corpus },
        { label: "Starting monthly withdrawal", value: startWithdrawal },
        { label: "Total withdrawn", value: totalWithdrawn },
      ],
      series,
    };
  },
};

export default config;
